// extracted by mini-css-extract-plugin
export default {"root":"LongTextModal_root__sVr6D","body":"LongTextModal_body__K9OF8"};